import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { CatModal } from '@blocks-react/components/Modal';
export const Modal = forwardRef(({ children, ...modalProps }, ref) => {
    return (_jsx(CatModal, { ref: ref, ...modalProps, children: children }));
});
